import "./chat.scss";

import { ChatReceiver, ChatRecord } from "./chat-types";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";

import ChatContext from "../../context/chat-context";
import ChatMessageItem from "./component/chat-message-item";
import { ChatPrivilege } from "@zoom/videosdk";
import ChatReceiverContainer from "./component/chat-receiver";
import { Input } from "antd";
import ZoomContext from "../../context/zoom-context";
import produce from "immer";
import { useCallCenter } from "../../../context/CallCenterContext";
import { useMount } from "../../hooks";
import { useParticipantsChange } from "./hooks/useParticipantsChange";

interface ChatContainerProps {
    fnRemoveFrames: () => void;
    setMedicIsInChat: any;
    medicIsInChat: boolean;
    isFullScreen?: boolean;
    chatRecords: ChatRecord[];
    setChatRecords: React.Dispatch<React.SetStateAction<ChatRecord[]>>;
    patientIsInChat: boolean;
    setPatientIsInChat: any;
}

const { TextArea } = Input;
const ChatContainer = (props: ChatContainerProps) => {
    const zmClient = useContext(ZoomContext);
    const chatClient = useContext(ChatContext);
    const [currentUserId, setCurrentUserId] = useState<number>(0);
    const [chatReceivers, setChatReceivers] = useState<ChatReceiver[]>([]);
    const [chatPrivilege, setChatPrivilege] = useState<ChatPrivilege>(ChatPrivilege.All);
    const [chatUser, setChatUser] = useState<ChatReceiver | null>(null);
    const [isHost, setIsHost] = useState<boolean>(false);
    const [isManager, setIsManager] = useState<boolean>(false);
    const [chatDraft, setChatDraft] = useState<string>("");
    const chatWrapRef = useRef<HTMLDivElement | null>(null);
    const { handleClickIniciarConsulta } = useCallCenter();
    const [patientIsConnected, setPatientIsConnected] = useState(false);
    const [medicIsConnected, setMedicIsConnected] = useState(false);

    const onChatMessage = useCallback(
        (payload: ChatRecord) => {
            props.setChatRecords(
                produce((records: ChatRecord[]) => {
                    const length = records.length;
                    if (length > 0) {
                        const lastRecord = records[length - 1];
                        if (
                            payload.sender.userId === lastRecord.sender.userId &&
                            payload.receiver.userId === lastRecord.receiver.userId &&
                            payload.timestamp - lastRecord.timestamp < 1000 * 60 * 5
                        ) {
                            if (Array.isArray(lastRecord.message)) {
                                lastRecord.message.push(payload.message as string);
                            } else {
                                lastRecord.message = [lastRecord.message, payload.message as string];
                            }
                        } else {
                            records.push(payload);
                        }
                    } else {
                        records.push(payload);
                    }
                })
            );
            if (chatWrapRef.current) {
                chatWrapRef.current.scrollTo(0, chatWrapRef.current.scrollHeight);
            }
        },
        [chatWrapRef]
    );
    const onChatPrivilegeChange = useCallback(
        (payload) => {
            setChatPrivilege(payload.chatPrivilege);
            if (chatClient) {
                setChatReceivers(chatClient.getReceivers());
            }
        },
        [chatClient]
    );
    const onChatInput = useCallback((event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setChatDraft(event.target.value);
        // if (chatClient) {
        //     chatClient.send("Tip: " + event.target.value, chatUser!.userId);
        // }
    }, []);
    useEffect(() => {
        zmClient.on("chat-on-message", onChatMessage);
        return () => {
            zmClient.off("chat-on-message", onChatMessage);
        };
    }, [zmClient, onChatMessage]);
    useEffect(() => {
        zmClient.on("chat-privilege-change", onChatPrivilegeChange);
        return () => {
            zmClient.off("chat-privilege-change", onChatPrivilegeChange);
        };
    }, [zmClient, onChatPrivilegeChange]);
    useParticipantsChange(zmClient, () => {
        if (chatClient) {
            const userId = zmClient.getSessionInfo().userId;
            const userName = zmClient.getSessionInfo().userName;
            console.log("se cuentan cuantos usuarios hay", zmClient.getAllUser());
            const receivers = chatClient.getReceivers();
            if (receivers) {
                if (receivers.length === 1 && !medicIsConnected) {
                    if (!props.medicIsInChat) {
                        chatClient.send(`Te has unido a la sala como: ${userName}`, 0);
                    }
                    setMedicIsConnected(true);
                    setPatientIsConnected(false);
                    props.setPatientIsInChat(false);
                    props.setMedicIsInChat(true);
                }

                if (receivers.length > 1 && !patientIsConnected) {
                    //INICIAR AUTOMATICAMENTE
                    var participants = zmClient.getAllUser();
                    if (participants) {
                        var patients = participants.filter((x) => !x.isHost);
                        // console.log("Paciente encontrado", patients, receivers);
                        if (patients.length > 0) {
                            var firstPatient = patients[0];
                            // const nombrePacienteFolio = receivers[receivers.length - 1].displayName;
                            const nombrePacienteFolio = firstPatient.displayName;
                            if (!props.patientIsInChat) {
                                chatClient.send(`Paciente ${nombrePacienteFolio} se ha unido a la sala`, 0);
                            }
                            setPatientIsConnected(true);
                            props.setPatientIsInChat(true);
                            setMedicIsConnected(false);
                            props.setMedicIsInChat(false);
                            // localStorage.setItem("sFolio", nombrePacienteFolio);
                            // handleClickIniciarConsulta();
                        }
                    }
                }
                if (receivers.length == 1 && patientIsConnected) {
                    //INICIAR AUTOMATICAMENTE
                    chatClient.send(`Se ha perdido la conexión con el paciente`, 0);
                }
                setChatReceivers(receivers);
            }
            // console.log("On participants change", chatClient.getReceivers(), zmClient.getSessionInfo());
        }
        props.fnRemoveFrames();
        setIsHost(zmClient.isHost());
        // setIsManager(zmClient.isManager());
    });
    useEffect(() => {
        if (chatUser) {
            const index = chatReceivers.findIndex((user) => user.userId === chatUser.userId);
            if (index === -1) {
                setChatUser(chatReceivers[0]);
            }
        } else {
            if (chatReceivers.length > 0) {
                setChatUser(chatReceivers[0]);
            }
        }
    }, [chatReceivers, chatUser]);
    const setChatUserId = useCallback(
        (userId) => {
            const user = chatReceivers.find((u) => u.userId === userId);
            if (user) {
                setChatUser(user);
            }
        },
        [chatReceivers]
    );
    const sendMessage = useCallback(
        (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
            event.preventDefault();
            if (chatUser && chatDraft) {
                chatClient?.send(chatDraft, chatUser?.userId);
                setChatDraft("");
            }
        },
        [chatClient, chatDraft, chatUser]
    );
    useMount(() => {
        setCurrentUserId(zmClient.getSessionInfo().userId);
        if (chatClient) {
            setChatPrivilege(chatClient.getPrivilege());
        }
    });
    return (
        <div className="chat-container" style={props.isFullScreen ? { height: "100%" } : {}}>
            <div className="chat-wrap" style={props.isFullScreen ? { height: "100%" } : {}}>
                {/* <h3>Chat</h3> */}
                {/* <button onClick={ExpulsaTodos}>Expulsar a todos</button> */}
                <div className="chat-message-wrap" ref={chatWrapRef}>
                    {props.chatRecords.map((record) => (
                        <ChatMessageItem
                            record={record}
                            currentUserId={currentUserId}
                            setChatUser={setChatUserId}
                            key={record.timestamp}
                        />
                    ))}
                </div>
                {ChatPrivilege.NoOne !== chatPrivilege || isHost || isManager ? (
                    <>

                        <div className="chat-message-box" style={props.isFullScreen ? { width: 300, padding: 0 } : {}}>
                            <TextArea
                                onPressEnter={sendMessage}
                                onChange={onChatInput}
                                value={chatDraft}
                                placeholder="Escriba su mensaje aquí ..."
                            />
                        </div>
                    </>
                ) : (
                    <div className="chat-disabled">Chat disabled</div>
                )}
            </div>
        </div>
    );
};

export default ChatContainer;
